<template>
  <div class="protocol">
    <div class="T_title" style="text-align: center">{{appName}} privacy Agreement</div>
    <div class="T_content">
      {{appName}}  Privacy Policy
      <br /><br />
      Use of {{appName}} through the mobile application may involve the collection and use of your information.
      This Privacy Policy explains and informs you how {{appName}} collects,
      uses and discloses information related to your access and use of our Services through our mobile applications
      <br /><br />
      <b>It is important for you to understand this Privacy Policy and how your information is protected,
        so please read this Privacy Policy carefully.</b>
      <br /><br />
      <b>This privacy policy will help you understand the following:</b>
      <br /><br />
      1. How we collect and use your personal information
      <br /><br />
      2. How we share, transfer and publicly disclose your personal information
      <br /><br />
      3. How we use cookies, similar technologies and SDK technologies
      <br /><br />
      4. How we protect your personal information
      <br /><br />
      5. How you manage your personal information
      <br /><br />
      6. How we process personal information of minors
      <br /><br />
      7. How we store your personal information
      <br /><br />
      8. Notification of Agreement Changes
      <br /><br />
      9.How to contact us
      <br /><br />
      <b>Introduction</b>
      <br /><br />
      {{appName}} strictly keeps the user information it collects confidential and has established a sound user information
      protection system to provide every user with reliable and assured services.
      <br /><br />
      <b>1.How we collect and use your personal information </b>
      <br /><br />
      Personal information refers to various information recorded electronically or in other ways that can identify a
      specific natural person or reflect the activities of a specific natural person alone or in
      combination with other information, including name, date of birth, personal biometric information,
      address, communication contact information, Communication records and content, account passwords,
      property information, health and physiological information, transaction information, etc.
      <br /><br />
      Sensitive personal information refers to personal information that, once leaked, illegally provided or misused,
      may endanger personal and property safety, easily lead to damage to personal reputation, physical and mental health,
      or discriminatory treatment, including personal biometric information, bank account numbers, communication records and Content, property information, whereabouts, health and physiological information,
      transaction information, personal information of children under 14 years old (inclusive), etc.
      <br /><br />
      <b>You understand and agree:</b>
      <br /><br />
      1.We are committed to creating a variety of products and services to meet your needs.
      Because of the products and services we provide to you There are many types,
      and the specific range of products/services chosen by different users is different. Correspondingly,
      the personal data collected and used ，The type and scope of personal information will be different,
      please refer to the specific product/service functions;
      <br /><br />
      2.In order to bring you a better product and service experience, we continue to work hard to improve our technology.
      As a result, we may launch new or optimized functions from time to time,
      and may need to collect and use new personal information or change personal information.
      Purpose or manner of use. In this regard, we will separately explain to you the purpose,
      scope and use of the corresponding information by updating this policy, pop-up windows, page prompts, etc.,
      and provide you with a way to choose your consent, and after obtaining your express consent Collect and use.
      During this process, if you have any questions, comments or suggestions, you can contact us through the various contact methods we provide,
      and we will answer you as soon as possible.
      <br /><br />
      3.We may use information collected through certain features for our other services.
      For example, we may use the information we collect when you use one of our functions or services to provide you with specific content in another function or service,
      including displaying advertisements and providing information security tips for the content you have read. ,
      perform indirect crowd profiling based on feature tags and provide more accurate and personalized services and content,
      etc. If we use your personal information beyond the scope directly or reasonably related to the stated purpose at the time of collection,
      we will inform you again and obtain your express consent before using your personal information.
      <br /><br />

      <b>Special Note:</b> We provide user-recommended services. The nickname, age, gender, zodiac sign, industry, work field,
      company, hometown, frequent haunts, personalized signature, uploaded avatar, photos,
      public updates and other information you fill in your personal information may be Shared or recommended to the site or other software by other users.
      <br /><br />

      <b> Business functions that collect personal information and personal information collected</b>
      According to the "Regulations on the Scope of Personal Information Necessary for Common Types of Mobile Internet Applications",
      {{appName}} App is a "social communication"App", the basic functional service of social communication APP is "providing text,
      pictures, voice, video and other online instant messaging services". Necessary personal information includes:
      <br /><br />
      1. Registered user email, user nickname, user gender, user country, birth date.
      The types of personal information collected by the functions of the products or services we provide,
      as well as the rules for collecting and using personal information
      The rules (such as the purpose and method of collecting and using personal information) are as follows:
      <br /><br />
      1.Business function: Register as a user. When you register for the {{appName}} service,
      in order to complete the account creation, you need to provide the following information: email, account nickname, age,
      date of birth, country, and personal avatar. This information is collected to help you complete {{appName}} account registration and social functions.
      We will determine whether you are installing, accessing and using the "{{appName}}" software and related services or when the software is running in the background.
      The specific permissions granted collect information related to the device you are using, including device model,
      operating system version, setting parameters, device configuration, device identification (IMEI/AndroidID/OAID/IDFA/IDFV/MEID/UDID/SIM card IMSI information/ICCID /SIM card status/VAID/AAID, etc.),
      device serial number, MAC address, device network information (operator information/WIFI information/WIFI status/WIFI list/SSID/BSSID),
      device environment, software list/application list, operation process information,
      sensor list and other software and hardware feature information) to ensure the safe operation of software and services,
      as well as the quality and efficiency of operations.
      <br /><br />
      2.Business function: Chat. When you use the chat service, we do not require you to provide information,
      but in order to ensure your normal use of the chat service, maintain the normal operation of the service,
      improve and optimize our service experience, and protect the security of your account,
      we will collect and use Your account information. In the chat interface, there are functions to send pictures,
      send voice, and send video call requests. When you operate, we will obtain "photo album permissions" and "microphone permissions" from you.
      This helps us provide you with better services and experience, but if you do not provide this information,
      it will not affect the basic business functions of using this service.
      <br /><br />
      3：Business function: video call. When you use the video call service, you need to provide "cLuvina permission" and "microphone permission",
      which will help us provide you with better service and experience. If this permission is not provided, normal video call services will not be possible.
      <br /><br />
      4：Business function: View the circle of friends. When you use the Moments Viewing service, we do not require you to provide any information.
      <br /><br />
      5：Business function: View user homepage. When you view the user's homepage, you can view the album pictures or videos uploaded by the other party without obtaining your special permissions.
      But when you initiate a video call on the user homepage, you need to provide "cLuvina permissions" and "microphone permissions",
      which will help us provide you with better services and experience. If this permission is not provided, normal video call services will not be possible.
      <br /><br />
      6.Business function: data editing. Data editing includes (user avatar, user nickname, user age, user date of birth, user country).
      When you change the user avatar, we will obtain your "photo album permissions". You do not need to provide this permission,
      and it will not affect the use of basic business functions.
      <br /><br />
      7.Business functions: payment function. The payment function is provided to you by a third-party payment institution that cooperates with us.
      The third-party payment institution will collect your information and we will not be able to obtain your information.
      Refusal to provide information will only make you unable to use the above payment function, but it will not Other basic functions that affect your use of {{appName}}.
      <br /><br />
      8.Business function: notification message. In order to allow you to receive message reminders alternately,
      we will use your authorized power-on automatic startup permission, collect startup program information,
      and push message reminders to you in a timely manner to prevent you from missing messages. You can turn off this permission in the phone settings.
      <br /><br />
      The services we provide may require you to turn on your cLuvina (cLuvina), photo album (picture library), microphone (language,audio, video),
      to realize the collection and use of the information involved in these permissions. The corresponding device permissions will not be turned on by default.
      When important or sensitive device permissions are involved, when you use the corresponding business functions,
      we will ask for your consent in a separate pop-up window to turn them on again; you can set the functions on your device.
      You can check the status of the above permissions item by item, and you can decide whether to turn these permissions on or off at any time.
      Please note that when you turn on any permission, you authorize us to collect and use relevant personal information to provide you with corresponding services.
      Once you close any permission, you cancel the authorization, and we will no longer continue to collect based on the corresponding permission.
      and use related personal information, and cannot provide you with services corresponding to this permission.
      However, your decision to turn off permissions will not affect the previous collection and use of information based on your authorization.
      <br /><br />
      You understand and agree that for the contact information (such as email) you provide during the use of products and/or services,
      we may send multiple types of notifications to one or more of them during operations for user messages. Notification, security verification
      , user experience research, etc.;
      <br /><br />
      If the information you provide contains the personal information of other users,
      you need to ensure that you have obtained legal authorization before providing such personal information to {{appName}}.。
      <br /><br />
      The information you provide will continue to be used by us during your use of this service. When you cancel your account or cancel the use of a certain function,
      we will stop using it as soon as possible to anonymize it or delete the above information in accordance with the requirements of applicable laws and regulations.
      <br /><br />
      <b>How we use the information we collect</b>
      <br /><br />
      We will use your information for the purposes stated above. If we use information for other purposes not specified in this policy,
      or if we use information collected for specific purposes for other purposes, or if we proactively obtain your personal information from a third party,
      we will obtain your consent in advance. . If we obtain your information indirectly from a third party,
      we will clearly require the third party in writing before collection to collect personal information after obtaining your consent in accordance with the law,
      and inform you of the content of the shared information, which involves sensitive information. Your explicit confirmation is required before it is provided to us for use,
      and the third party is required to make a commitment to the legality and compliance of the source of personal information. If the third party violates the rules,
      we will clearly require the other party to bear corresponding legal responsibilities; at the same time, ,
      our professional security team will carry out security protection for personal information (including classification of sensitive information,
      access control for the use of sensitive information, encrypted storage of sensitive information, etc.).
      We will use no less than the same protection methods as we do for our own users' personal information. and measures to protect indirectly obtained personal information.
      <br /><br />
      Unified exceptions to authorization: You fully understand and agree that we do not need your authorization to collect and use your personal information under the following circumstances,
      and we may not agree to your correction/modification, deletion, cancellation, or withdrawal of consent. , request for letter:
      1. Relevant to our performance of obligations stipulated in laws and regulations;
      <br /><br />
      2. Related to national security and national defense security;
      <br /><br />
      3. Relevant to public safety, public health, and maLuvin public interests;
      <br /><br />
      4. Relevant to criminal investigation, prosecution, trial and execution of judgments;
      <br /><br />
      5. To protect the life, property and other maLuvin legitimate rights and interests of the personal information subject or other individuals but it is difficult to obtain your consent;
      <br /><br />
      6. The personal information collected is disclosed to the public by you;
      <br /><br />
      7. Collect personal information from legally publicly disclosed information
      <br /><br />
      Please be aware that, in accordance with applicable laws,
      if we take technical measures and other necessary measures to process personal information so that the data recipient cannot re-identify a specific individual and cannot recover it,
      or we may conduct de-identification research on the collected information. ,
      statistical analysis and prediction, used to improve Tantan’s content and layout, provide product or service support for business decisions,
      and improve our products and services (including using anonymous data for machine learning or model algorithm training),
      such processing The subsequent use of data does not require further notification to you and your consent.
      If we stop operating {{appName}} products or services, we will promptly stop collecting your personal information and
      will stop Operational notices will be delivered one by one or announced to inform you that the personal information held will be deleted or anonymized.
      <br /><br />
      <b>Information you share</b>
      <br /><br />
      You can share your relevant information with other users through our services. For example, text and photos you make public in profile edits.
      Please note that this may contain your personal information and sensitive information. Please carefully consider disclosing your relevant personal sensitive information.
      You can delete information you have shared publicly through the settings in the Service or through the instructions we provide. However,
      please note that this information may still be stored independently by other users or non-affiliated third parties not controlled by us.
      <br /><br />
      <b>
        2.How we share, transfer, and publicly disclose your personal information
      </b>
      <br /><br />
      Shared
      <br /><br />
      We will not share your personal information with companies, organizations and individuals other than {{appName}} service providers, except in the following circumstances:
      <br /><br />
      1. Sharing with explicit consent: After obtaining your explicit consent, we will share your personal information with other parties;
      <br /><br />
      2. Sharing under legal circumstances: We may share your personal information externally in accordance with laws and regulations,
      litigation and dispute resolution needs, or as required by administrative and judicial authorities in accordance with the law;
      <br /><br />
      3. Sharing with affiliated companies: In order for us to jointly provide you with services based on associated accounts,
      recommend information that you may be interested in, or protect the personal and property safety of {{appName}} affiliated companies or other users or
      the public from infringement, your personal information may Will be shared with our affiliates. We will only share necessary personal
      information (for example, to facilitate your use of our affiliated company products or services through your {{appName}} account,
      we will share your necessary account information with affiliated companies) and will be bound by the purposes stated in this Privacy Policy.
      If we share your sensitive personal information or our affiliated companies change the use and processing purposes of personal information,
      we will ask for your authorization and consent again;
      <br /><br />
      <b>3.How we use Cookies, SDK technology</b>
      <br /><br />
      <b>Cookie</b>
      <br /><br />
      In order to ensure the normal operation of the website, provide you with an easier access experience,
      and recommend content that may be of interest to you, we may store small data files called cookies on your computer or mobile device.
      Cookies usually contain identifiers, site names, and some numbers and characters. Cookies allow websites to store data such as your preferences.
      You can perform corresponding data clearing operations in your browser. If you clear it, you may not be able to use the services or corresponding functions provided by us that rely on Cookies.
      <br /><br />
      <b>SDK</b>
      <br /><br />
      SDK technology is provided by third-party organizations that cooperate with us. We can only know the permissions they require to obtain authorization.
      The third party will need to collect your information, and we will not be able to obtain your information unless the third party explicitly discloses
      to us the sensitive information to be collected. The permissions requested by third parties and the sensitive information collected and explicitly
      disclosed to us are detailed below.
      <br /><br />
      Google firebase Push SDK
      <br /><br />
      Three-party payment SDK
      <br /><br />
      NetEase Yunxin SDK
      <br /><br />
      Shengwang SDK
      <br /><br />
      AppsFlyer SDK
      <br /><br />
      Facebook SDK
      <br /><br />
      HuaWei Push SDK
      <br /><br />
      The third party's refusal to provide information will only prevent you from using the functions provided by the technology provided by the third party,
      but it will not affect your use of other functions of {{appName}}.
      <br /><br />
      4. Sharing with authorized partners: We may entrust authorized partners to provide you with certain services or perform functions on our behalf.
      We will only share your personal information for legal, legitimate, necessary, specific and clear purposes with authorized partners.
      They will only have access to the information necessary to perform their duties and may not use this information for any other purpose.
      <br /><br />
      <b>Transfer</b>
      <br /><br />
      We will not transfer your personal information to any company, organization or individual, except in the following circumstances:
      <br /><br />
      1. Transfer with explicit consent; after obtaining your explicit consent, we will transfer your personal information to other parties;
      <br /><br />
      2. When it comes to mergers, acquisitions or bankruptcy liquidations, or other situations involving mergers, acquisitions or bankruptcy liquidations,
      if personal information is transferred, we will require new companies and organizations that hold your personal information to continue to be bound by this policy.
      Otherwise, we will require the company, organization and individual to re-obtain your authorization and consent.
      <br /><br />
      <b>public disclosure</b>
      <br /><br />
      We will only publicly disclose your personal information under the following circumstances:
      <br /><br />
      1. We may publicly disclose your personal information with your explicit consent or based on your active choice;
      <br /><br />
      2. If we determine that you have violated laws and regulations or seriously violated {{appName}}-related agreement rules,
      or to protect the personal and property safety of users of {{appName}} and its affiliated companies or the public from infringement,
      we may impose levies on you in accordance with laws, regulations or {{appName}}-related agreement rules. With your consent, disclose information about
      <br /><br />
      <b>4.How we protect your personal information</b>
      <br /><br />
      In order to protect the security of your information, we will strictly abide by the technical measures and operational procedures required by laws,
      regulations and other normative documents to protect the confidentiality of your information, and at the same time:
      <br /><br />
      1. We strive to provide security for users’ personal information to prevent illegal use, unauthorized access and disclosure,
      leakage, damage and loss of users’ personal information. We will use various security protection measures within a reasonable security level
      to protect the security of information. For example, we will use encryption technology (such as SSL), anonymization, encrypted storage and other means
      to protect your personal information, establish a trusted protection mechanism to prevent personal information from being maliciously attacked;
      establish an access control mechanism and comply with minimum permissions principles to ensure that only authorized personnel can access personal information;
      conduct security and personal information protection training courses to enhance employees' awareness of the protection of personal information.
      <br /><br />
      2. We have an industry-leading data security management system that is centered on data and revolves around the data life cycle,
      improving the security of the entire system from multiple dimensions such as organizational construction, system design, personnel management,
      and product technology. We have established specialized management systems, processes and organizations to ensure the security of personal information.
      For example, we strictly limit who can access information, require them to comply with confidentiality obligations, and conduct audits.
      If a security incident such as personal information leakage occurs, we will activate an emergency plan to prevent the security incident from expanding,
      and inform you through push notifications, announcements, etc.
      <br /><br />
      3. We will take reasonable and feasible measures to try our best to avoid collecting irrelevant personal information.
      We will only retain your personal information for the period necessary to achieve the purposes stated in this policy,
      unless an extension of the retention period is required or permitted by law.
      <br /><br />
      4. The Internet is not an absolutely secure environment. We strongly recommend that you do not use communication methods other than those recommended by
      Tantan to send personal information. You can connect and share with each other through our services. When you create communications,
      transactions or shares through our services, you can independently choose the objects of communication,
      transactions or sharing as third parties who can see your transaction content, contact information,
      communication information or shared content and other related information.
      If you find that your personal information, especially your account or password,
      has been leaked, please contact Tantan custVolkie service immediately so that we can take appropriate measures according to your application.
      <br /><br />
      Please note that the information you voluntarily share or even share publicly when using our services may involve your or others'
      personal information or even personal sensitive information. For example, if you choose to upload personal information when posting updates or
      in public places such as group chats and circles. Please consider your own pictures more carefully.
      <br /><br />
      <b>5.How you manage your personal information</b>
      <br /><br />
      <b>  Personal information inquiry</b>
      <br /><br />
      You have the right to access your personal information, except for exceptions provided by laws and regulations.
      You can access your personal information by yourself in the following ways: Perform corresponding operations to modify it through [Me-Upper Right Corner-Settings]。
      <br /><br />
      Personal Data 1 - If you want to access or edit your nickname, avatar, country,
      date of birth, self-introduction and other information, you can log in to your account and click [Me] to enter the personal center,
      and click [Personal Avatar] ] View/Edit performs such operations.
      <br /><br />
      <b>   Correction of personal information</b>
      <br /><br />
      When you find errors in the personal information we process about you, you have the right to ask us to make corrections or additions.
      You can submit an application for correction or supplement through the methods listed in this "Personal Information Inquiry".
      <br /><br />
      <b>  Personal information deletion</b>
      <br /><br />
      You can delete some of your personal information through the methods listed in this "Personal Information Inquiry".
      <br /><br />
      You can make a request to us to delete personal information in the following situations:
      <br /><br />
      1. If our processing of personal information violates laws and regulations;
      <br /><br />
      2. If we collect and use your personal information without your explicit consent;
      <br /><br />
      3. If our handling of personal information seriously violates the agreement with you;
      <br /><br />
      4. If you no longer use our products or services, or you actively cancel your account;
      <br /><br />
      5. If we permanently no longer provide you with products or services.
      <br /><br />
      <b> Change the scope of your authorization and consent</b>
      <br /><br />
      Each business function requires some basic personal information to be completed. In addition, for additional personal information For collection and use, you can give or withdraw your authorization by yourself or contact {{appName}} custVolkie service.
      <br /><br />
      <b>  6.How we process personal information of minors</b>
      <br /><br />
      <b>  This software prohibits registration and use by minors</b>
      <br /><br />
      The Services are not directed to children under the age of eighteen (18),
      and we do not knowingly accept or sell personally identifiable information from children under the age of eighteen as part of our Services.
      If we discover that we have inadvertently received personally identifiable information from a user under the age of 18 on the Service,
      we will delete such information from our records. If we change our practices in the future,
      we will obtain prior verifiable parental consent before collecting any personally identifiable information from children under 18 as part of the Service.
      <br /><br />
      <b>  7.How we store your personal information</b>
      <br /><br />
      We operate and may continue to operate servers in multiple jurisdictions around the world,
      so the servers on which your personal information is used and stored may not be located in your jurisdiction.
      You consent to the transfer of your personal information (within and outside your jurisdiction) for the purposes described in this privacy policy.
      <br /><br />
      <b>  8. Change notification</b>
      <br /><br />
      We reserve the right to change this Privacy Policy at our sole discretion.
      You can review updates to our privacy policy at any time via a link on our website.
      You consent to the posting of {{appName}} electronic communications and/or revised Privacy Policy.
      and you agree that such electronic communications or postings shall constitute notice to you of our privacy practices.
      We reserve the right to modify this policy from time to time, so please check back frequently. If we make material changes to this policy,
      we will notify you by posting the revised Privacy Policy or a notice on our website, or as required by law.
      You agree to review the Privacy Policy periodically to be aware of any changes.
      You agree that your continued use of the Service after we post a revised Privacy Policy or provide notice on our website constitutes your acceptance of the
      revised Privacy Policy. If you do not agree to the terms of the Privacy Policy, you should not use the Service.

      <br /><br />
      <b>  9.How to contact us</b>
      <br /><br />
      If you have any questions about our Privacy Policy or any privacy-related matters, please contact us via email at 【{{appName}}@{{appName}}.site】.

    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  created() {
  }
};
</script>

<style scoped>
.protocol {
  font-size: 1rem;
  margin-bottom: 1rem;
  color: #727272;
  margin-left: 0.4rem;
  margin-right: 0.4rem;
}
.bt {
  font-size: 1rem;
  margin: 0.2rem 0px;
  color: #7f1146;
}
</style>